export default {
  ChannelWarehouseManagement: {
    Header: {
      name: 'Channel Warehouse Name',
      code: 'Channel Warehouse Code',
      status: 'Channel Warehouse Status',
      Add: 'Add channel warehouse',
    },
    Main: {
      time: 'CreationTime',
      Operation: 'Operate',
      ps: 'Delete or not ?',
      ps1: 'Channel warehouse operation, continue or not ?',
    },
    form: {
      Edit: 'Edit Channel Warehouse',
      Create: 'Add channel warehouse',
      Basic: 'Account Information',
      name: 'Channel Warehouse Name',
      code: 'Channel Warehouse Code',
      autoCode: 'System Auto',
      ruleName: 'Please enter the channel warehouse name',
    },
  },
};
